// extracted by mini-css-extract-plugin
export var bottomWave = "bc_cV";
export var container = "bc_b";
export var middleWave = "bc_cT";
export var section = "bc_d";
export var subtitle = "bc_cj";
export var text = "bc_b0";
export var textContainer = "bc_cW";
export var title = "bc_h";